module.exports = __webpack_public_path__ + "img/banner.7e8ac751.jpg";